import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'letter-e-small', 'LetterESmall', [["path",{"d":"M14 8h-4v8h4"}],["path",{"d":"M10 12h2.5"}]]);